module.exports = __webpack_public_path__ + "static/icons/extra-mis-pagos.6bd6c3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payments/extra-mis-pagos.svg
// module id = qU/y
// module chunks = 1